<template>
    <div id="checklist">
        <h2>Shrnutí</h2>

        <ul class="checklist-items">
            <li class="checklist-item"
                v-bind:class="{ 'checklist-item-success': mazlicek.jmeno.valid, 'checklist-item-danger': !mazlicek.jmeno.valid, 'active-item': mazlicek.step.current === 1 }">
                <router-link :to="{ name: 'jmenomazlicka' }">
                    <div class="checklist-label">Jméno mazlíčka</div>
                    <div class="checklist-value" v-if="mazlicek.jmeno.valid">{{ mazlicek.jmeno.value }}</div>
                    <div class="checklist-value" v-else>Nevyplněno</div>
                </router-link>
            </li>
            <li class="checklist-item"
                v-bind:class="{ 'checklist-item-success': mazlicek.step.current >= 2, 'active-item': mazlicek.step.current === 2 }">
                <router-link v-if="mazlicek.step.current >= 2" :to="{ name: 'rasa' }">
                    <div class="checklist-label">Plemeno</div>
                    <div class="checklist-value" v-if="mazlicek.rasa.typ === 'app_rasa'">
                        {{ mazlicek.rasa.autocomplete.keyword }}
                    </div>
                    <div class="checklist-value"
                         v-if="mazlicek.rasa.typ === 'app_velikost' && velikost && velikost.title">
                        {{ velikost.title }}
                    </div>
                    <div v-if="!mazlicek.rasa.typ && (mazlicek.rasa.typ === 'app_velikost' && velikost && velikost.title)" class="checklist-value">Nevyplněno</div>
                </router-link>
                <span v-else>
                    <div class="checklist-label">Plemeno</div>
                    <div class="checklist-value" v-if="mazlicek.rasa.typ === 'app_rasa'">
                        {{ mazlicek.rasa.autocomplete.keyword }}
                    </div>
                    <div class="checklist-value"
                         v-if="mazlicek.rasa.typ === 'app_velikost' && velikost && velikost.title">
                        {{ velikost.title }}
                    </div>
                    <div v-if="!mazlicek.rasa.valid" class="checklist-value">Nevyplněno</div>
                </span>
            </li>
<!--            <li class="checklist-item"-->
<!--                v-bind:class="{ 'checklist-item-success': mazlicek.fotografie.valid, 'checklist-item-danger': !mazlicek.fotografie.valid, 'active-item': mazlicek.step.current === 3 }">-->
<!--                <router-link v-if="mazlicek.step.current >= 3" :to="{ name: 'fotografie' }">-->
<!--                    <div class="checklist-label">Fotografie</div>-->
<!--                    <div v-if="mazlicek.fotografie.typ === 'foto' || mazlicek.fotografie.typ == 'ikona'">-->
<!--                        <div class="checklist-value">Ano</div>-->
<!--                    </div>-->
<!--                    <div class="checklist-value" v-if="!mazlicek.fotografie.valid">Nevyplněno</div>-->
<!--                </router-link>-->
<!--                <span v-else>-->
<!--                    <div class="checklist-label">Fotografie</div>-->
<!--                    <div v-if="mazlicek.fotografie.typ === 'foto' || mazlicek.fotografie.typ == 'ikona'">-->
<!--                        <div class="checklist-value">Ano</div>-->
<!--                    </div>-->
<!--                    <div class="checklist-value" v-if="!mazlicek.fotografie.valid">Nevyplněno</div>-->
<!--                </span>-->
<!--            </li>-->
            <li class="checklist-item"
                v-bind:class="{ 'checklist-item-success': mazlicek.narozeniny.valid, 'checklist-item-danger': !mazlicek.narozeniny.valid, 'active-item': mazlicek.step.current === 3 }">
                <router-link v-if="mazlicek.step.current >= 3" :to="{ name: 'narozeniny' }">
                    <div class="checklist-label">Narozeniny</div>
                    <div class="checklist-value" v-if="mazlicek.narozeniny.valid">{{ formatDatumNarozeni }}</div>
                    <div class="checklist-value" v-else>Nevyplněno</div>
                </router-link>
                <span v-else>
          <div class="checklist-label">Narozeniny</div>
          <div class="checklist-value" v-if="mazlicek.narozeniny.valid">{{ formatDatumNarozeni }}</div>
          <div class="checklist-value" v-else>Nevyplněno</div>
        </span>
            </li>
            <li class="checklist-item"
                v-bind:class="{ 'checklist-item-success': mazlicek.pohlavi.valid, 'checklist-item-danger': !mazlicek.pohlavi.valid, 'active-item': mazlicek.step.current === 4 }">
                <router-link v-if="mazlicek.step.current >= 4" :to="{ name: 'pohlavi' }">
                    <div class="checklist-label">Pohlaví</div>
                    <div class="checklist-value" v-if="mazlicek.pohlavi.valid">{{ mazlicek.pohlavi.value.charAt(0).toUpperCase() + mazlicek.pohlavi.value.slice(1) }}</div>
                    <div class="checklist-value" v-else>Nevyplněno</div>
                </router-link>
                <span v-else>
          <div class="checklist-label">Pohlaví</div>
          <div class="checklist-value" v-if="mazlicek.pohlavi.valid">{{ mazlicek.pohlavi.value }}</div>
          <div class="checklist-value" v-else>Nevyplněno</div>
        </span>
            </li>
            <li class="checklist-item"
                v-bind:class="{ 'checklist-item-success': mazlicek.hmotnostkondice.valid, 'checklist-item-danger': !mazlicek.hmotnostkondice.valid, 'active-item': mazlicek.step.current === 5 }">
                <router-link v-if="mazlicek.step.current >= 5" :to="{ name: 'hmotnostkondice' }">
                    <div class="checklist-label">Hmotnost a kondice</div>
                    <div class="checklist-value" v-if="mazlicek.hmotnostkondice.valid">
                        {{ kondiceValue }}
<!--                        <div class="hmotnost-kg"><span v-if="mazlicek.hmotnostkondice.kondice !== null"> , {{ kondicename.toLowerCase() }}</span>-->
<!--                        </div>-->
                    </div>
                 <!--   <div class="checklist-value" v-if="mazlicek.hmotnostkondice.valid"></div> -->
                    <div class="checklist-value" v-else>Nevyplněno</div>
                </router-link>
                <span v-else>
                    <div class="checklist-label">Hmotnost a kondice</div>
                    <div class="checklist-value" v-if="mazlicek.hmotnostkondice.valid">
                        {{ kondiceValue }}
                    </div>
                <!--    <div class="checklist-value" v-if="mazlicek.hmotnostkondice.valid"></div> -->
                    <div class="checklist-value" v-else>Nevyplněno</div>
                </span>
            </li>
            <li class="checklist-item"
                v-bind:class="{ 'checklist-item-success': mazlicek.pohyb.valid || mazlicek.jeStene, 'checklist-item-danger': !mazlicek.pohyb.valid && !mazlicek.jeStene, 'active-item': mazlicek.step.current === 6 }">
                <router-link v-if="mazlicek.step.current >= 6" :to="{ name: 'pohyb' }">
                    <div class="checklist-label">Aktivita</div>
                    <div class="checklist-value">{{ aktivitaValue }}</div>
                </router-link>
                <span v-else>
          <div class="checklist-label">Aktivita</div>
            <div class="checklist-value">{{ aktivitaValue }}</div>
        </span>
            </li>
            <li class="checklist-item"
                v-bind:class="{ 'checklist-item-success': mazlicek.alergie.valid, 'checklist-item-danger': !mazlicek.alergie.valid, 'active-item': mazlicek.step.current === 7 }">
                <router-link v-if="mazlicek.step.current >= 7" :to="{ name: 'alergie' }">
                    <div class="checklist-label">Zvýšená citlivost</div>
                    <div class="checklist-value" v-if="mazlicek.alergie.valid"><span
                            v-if="mazlicek.alergie.alergie">Ano</span><span v-else>Ne</span></div>
                    <div class="checklist-value" v-else>Nevyplněno</div>
                </router-link>
                <span v-else>
          <div class="checklist-label">Zvýšená citlivost</div>
          <div class="checklist-value" v-if="mazlicek.alergie.valid"><span
                  v-if="mazlicek.alergie.alergie">Ano</span><span v-else>Ne</span></div>
          <div class="checklist-value" v-else>Nevyplněno</div>
        </span>
            </li>
            <li class="checklist-item"
                v-bind:class="{ 'checklist-item-success': mazlicek.suroviny.valid, 'checklist-item-danger': !mazlicek.suroviny.valid, 'active-item': mazlicek.step.current === 8 }">
                <router-link v-if="mazlicek.step.current >= 8" :to="{ name: 'suroviny' }">
                    <div class="checklist-label">Složení</div>
                    <div class="checklist-value" v-if="mazlicek.suroviny.valid">
                        <span v-if="mazlicek.suroviny.valid && slozkaItems && slozkaItems[0]">
                            <span>{{ slozkaItems[0].title }}</span>
                        </span>
                    </div>
                    <div v-else class="checklist-value">Nevyplněno</div>
                </router-link>
                <span v-else>
                    <div class="checklist-label">Složení</div>
                    <div class="checklist-value" v-if="mazlicek.suroviny.valid">
                        <span v-if="mazlicek.suroviny.valid && slozkaItems && slozkaItems[0]">
                            <span>{{ slozkaItems[0].title }}</span>
                        </span>
                    </div>
                    <div v-else class="checklist-value">Nevyplněno</div>
                </span>
            </li>
        </ul>

        <!--ul class="checklist">
          <router-link v-for="item in items"
            :to="{ name:item.name }"
            :key="item.name"
            tag="li"
            v-bind:class="{ valid:isItemValid(item.name) }"
          >
            {{ item.label }}
          </router-link>
        </ul-->
        <div class="objednavka-btn" v-if="lastStep">
            <button class="button" @click="objednatBtn()">Přejít k objednávce</button>
         </div>
    </div>

</template>

<script>
    import moment from 'moment'
    import RightContentHeader from './RightContentHeader'
    import {apiSilex} from '../api'
    import filters from '../filters'

    export default {
        components: {
            'right-content-header': RightContentHeader
        },

        data: function () {
            return {
                mazlicek: this.$store.state.mazlicek,
                kondicename: '',
                aktivitaname: '',
                slozkaItems: null,
                velikost: null,
                items: [
                    {label: 'Jméno mazlíčka', name: 'jmenomazlicka', valid: false},
                    {label: 'Rasa', name: 'rasa', valid: false},
                    // {label: 'Fotografie', name: 'fotografie', valid: false},
                    {label: 'Narozeniny', name: 'narozeniny', valid: false},
                    {label: 'Pohlaví', name: 'pohlavi', valid: false},
                    {label: 'Hmotnost a kondice', name: 'hmotnostkondice', valid: false},
                    {label: 'Pohyb', name: 'pohyb', valid: false},
                    {label: 'Alergie', name: 'alergie', valid: false},
                    {label: 'Složení', name: 'suroviny', valid: false},
                    {label: 'Hotové krmivo', name: 'hotovekrmivo', valid: false}
                ]
            }
        },
        computed: {
            formatDatumNarozeni: function () {
                return moment(this.mazlicek.narozeniny.value).format('D.M.Y')
            },
            imageSrc: function () {
                return 'https://dummyimage.com/200x200/000/fff&amp;text=ico'
            },
            lastStep: function() {
                // return $('li:last-child').hasClass('checklist-item-success');
                return this.mazlicek.step.current > 9;
            },
            hmotnostReadable: function () {
                return filters.round(this.mazlicek.hmotnostkondice.hmotnost) + 'kg / ' +
                    filters.round(this.mazlicek.hmotnostkondice.hmotnost * 2.20462262) + 'lb'
            },
            aktivitaValue: function () {
                if(this.mazlicek.jeStene
                    && this.mazlicek.pohyb.valid)
                    return 'Neřeší se'
                else if (this.mazlicek.pohyb.valid) {
                    return this.aktivitaname
                } else {
                    return 'Nevyplněno'
                }
            },
            kondiceValue: function () {
                var kondiceValue = this.hmotnostReadable

                if(this.mazlicek.hmotnostkondice.kondice !== null && !this.mazlicek.jeStene){
                    kondiceValue += ', ' + this.kondicename.toLowerCase()
                }

                return kondiceValue
            }
        },
        beforeUpdate: function () {


//            url = '/slozka'
//            apiSilex.get(url).then(function (response) {
//                response.data.forEach(function (entry) {
//                    if (!self.slozky[entry.id_typ_slozky]) self.slozky[entry.id_typ_slozky] = {suroviny: {}}
//
//                    self.slozky[entry.id_typ_slozky].suroviny[entry.id] = entry
//                })
//            })
        },
        methods: {
            isItemValid: function (val) {
                switch (val) {
                    case 'jmenomazlicka':
                        return this.mazlicek.jmeno.valid
                    case 'rasa':
                        return this.mazlicek.rasa.valid
                    // case 'fotografie':
                    //     return this.mazlicek.fotografie.valid
                    case 'narozeniny':
                        return this.mazlicek.narozeniny.valid
                    case 'pohlavi':
                        return this.mazlicek.pohlavi.valid
                    case 'hmotnostkondice':
                        return this.mazlicek.hmotnostkondice.valid
                    case 'pohyb':
                        return this.mazlicek.pohyb.valid
                    case 'alergie':
                        return this.mazlicek.alergie.valid
                    case 'suroviny':
                        return this.mazlicek.suroviny.valid
                    case 'hotovekrmivo':
                        return this.mazlicek.hotovekrmivo.valid
                    default:
                        return false
                }
            },
            mountinMethod() {
                if(this.mazlicek.hmotnostkondice.kondice) {
                    apiSilex.get('/hmotnost').then(response => {
                        this.kondicename = response.data.filter(
                            item => item.id === this.mazlicek.hmotnostkondice.kondice
                        )[0].title // this.$store.commit('setMazlicek', this.mazlicek)
                    })
                }
                if(this.mazlicek.pohyb.id) {
                    apiSilex.get('/aktivita').then(response => {
                        this.aktivitaname = response.data.filter(
                            item => item.id === this.mazlicek.pohyb.id
                        )[0].title
                    })
                }
                if (this.mazlicek.suroviny.slozky[1]) {
                    let url = '/slozka'
                    apiSilex.get(url).then((response) => {
                        this.slozkaItems = response.data.filter((item) => {
                            return this.mazlicek.suroviny.slozky[1] == item.id && item.id_typ_slozky == 1
                        })
                    })
                }

                let _then = this
                apiSilex.get('/velikost').then(response => {
                    _then.velikost = response.data.filter(
                        item => item.id === _then.mazlicek.rasa.velikost
                    )[0]
                })
            },
                objednatBtn(){
                    this.$emit('activeTab',0);
                }
        },
        mounted() {
            this.mountinMethod()
        },
        watch: {
            'mazlicek.productLoaded': {
                deep: true,
                handler: function (val) {
                    if (val)
                        this.mountinMethod()
                }
            },
            'mazlicek.petLoaded': {
                deep: true,
                handler: function (val) {
                    if (val)
                        this.mountinMethod()
                }
            },
            'mazlicek.step.current': {
                deep: true,
                handler: function (val) {
                    this.mountinMethod()
                }
            },
            'mazlicek.jeStene': {
                deep: true,
                handler: function (val) {
                    this.mountinMethod()
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Checklist.vue?8ee2f358